let key = 0;

const keys = new WeakMap<any, number>();

export function getKey(value: any): string | number {
  switch (typeof value) {
    case "bigint":
      return `bigint:${value}`;
    case "number":
      return value;
    case "string":
      return `string:${value}`;
    case "object":
      if (value === null) {
        return "null";
      }
    case "symbol": {
      if (keys.has(value)) {
        return keys.get(value)!;
      }
      const k = key++;
      keys.set(value, k);
      return k;
    }
    case "undefined":
      return "undefined";
  }
  throw new Error(`Unsupported: ${value}`);
}
